import { playwrightUserAgent } from '@common/regexp/playwrightUserAgent';

const environment = process.env.APP_ENV || process.env.NODE_ENV;

/**
 * Indicates if the application is running locally
 */
export const isDevelopment = environment === 'development';

/**
 * Indicates if the the browser is a Playwright agent.
 */
export const isPlaywright = typeof navigator !== 'undefined' && playwrightUserAgent.test(navigator.userAgent);
